import { reaction } from "mobx";
import { flow, getEnv, types } from "mobx-state-tree";
import { endpoints } from "../api/ApiEndpoints";
import { api } from "../api/ApiService";
import { organizationSubscriptionService } from "../organization/OrganizationSubscription";
import { StorageModel } from "../storage/StorageModel";
import { ActivityTypes } from "./ActivityPricesStorage";

const CreditBalanceModel = types.model({
    balance: types.optional(types.frozen<number>(), -1)
})

export const CreditBalanceStorageModel = types
    .compose(CreditBalanceModel, StorageModel)
    .named("CreditBalanceStorageModel")
    .actions((self) => {
        return {
            mapResponse(response: number) {
                self.balance = response;
            },
            getCustomerPortalSessionLink: flow(function* () {
                const endpoint = endpoints.get("shop_orders");
                return yield getEnv(self).api.get(endpoint);
            }),
            validateRemainingBalance: flow(function* (activity: ActivityTypes) {
                const endpoint = endpoints.get("validate_user_balance");
                endpoint.routeParams = [activity];
                try {
                    yield getEnv(self).api.get(endpoint);
                    return true;
                } catch (error) {
                    return false;
                }
            }),
        }
    })
    .views((self) => ({
        get endpoint() {
            return endpoints.get("current_user_balance");
        },
        get isLoading() {
            return self.balance < 0;
        },
        get canLoadItems() {
            return getEnv(self).organizationSubscriptionService.key;
        },
    }))

export const creditBalanceStorage = CreditBalanceStorageModel.create({}, { api, organizationSubscriptionService });

reaction(
    () => organizationSubscriptionService.key,
    async () => {
        await creditBalanceStorage.load();
    }
);